module.exports = __webpack_public_path__ + "img/analyze_ui.64a706af.svg";